import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { BulkInvoiceJobMergeData, BulkInvoiceJobMergeSchema } from '../data/bulk.invoice.job.merge.data';
import { ContactMergeData, ContactMergeSchema } from '../data/contact.merge.data';

@MergeDataset({
    entity: ActivityEntityName.BulkInvoiceJob,
})
export class BulkInvoiceJobMergeDataset {
    @MergeSource({
        schema: BulkInvoiceJobMergeSchema,
    })
    job: BulkInvoiceJobMergeData;

    @MergeSource({
        schema: ContactMergeSchema,
        ignoreCustomFields: true,
    })
    jobPrimaryContact: ContactMergeData;
}